/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Proof_Panel_TaskInputs */

const en_mk_proof_panel_task = /** @type {(inputs: Mk_Proof_Panel_TaskInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`F1-T3 · Onboarding form validates +62 numbers`)
};

const id_mk_proof_panel_task = /** @type {(inputs: Mk_Proof_Panel_TaskInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`F1-T3 · Form onboarding memvalidasi nomor +62`)
};

/**
* | output |
* | --- |
* | "F1-T3 · Onboarding form validates +62 numbers" |
*
* @param {Mk_Proof_Panel_TaskInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_proof_panel_task = /** @type {((inputs?: Mk_Proof_Panel_TaskInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Proof_Panel_TaskInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_proof_panel_task(inputs)
	return en_mk_proof_panel_task(inputs)
});